import dayjs from 'dayjs';
import { isSameDate } from '../../../utils/is-same-date/is-same-date.js';
function getDayProps(_ref) {
  var date = _ref.date,
    month = _ref.month,
    hasValue = _ref.hasValue,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    value = _ref.value,
    excludeDate = _ref.excludeDate,
    disableOutsideEvents = _ref.disableOutsideEvents,
    range = _ref.range;
  var weekday = date.getDay();
  var weekend = weekday === 6 || weekday === 0;
  var outside = date.getMonth() !== month.getMonth();
  var selected = hasValue && isSameDate(date, value);
  var isAfterMax = maxDate instanceof Date && dayjs(maxDate).isBefore(date, "day");
  var isBeforeMin = minDate instanceof Date && dayjs(minDate).isAfter(date, "day");
  var shouldExclude = typeof excludeDate === "function" && excludeDate(date);
  var disabledOutside = disableOutsideEvents && outside;
  var disabled = isAfterMax || isBeforeMin || shouldExclude || disabledOutside;
  var hasRange = Array.isArray(range) && range.every(function (val) {
    return val instanceof Date;
  });
  var inclusiveRange = hasRange && [dayjs(range[0]).subtract(1, "day"), dayjs(range[1]).add(1, "day")];
  var firstInRange = hasRange && isSameDate(date, range[0]);
  var lastInRange = hasRange && isSameDate(date, range[1]);
  var inRange = hasRange && dayjs(date).isAfter(inclusiveRange[0], "day") && dayjs(date).isBefore(inclusiveRange[1], "day");
  var selectedInRange = firstInRange || lastInRange;
  return {
    selectedInRange: selectedInRange,
    selected: selected,
    disabled: disabled,
    inRange: inRange,
    firstInRange: firstInRange,
    lastInRange: lastInRange,
    weekend: weekend,
    outside: outside
  };
}
export { getDayProps };